var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSection2Icon1 = function SvgSection2Icon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "#F9F6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#section2-icon-1_svg__a)",
    stroke: "#6400FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.118 22.588H7.647a1.234 1.234 0 0 1-1.235-1.235c0-.684.551-1.235 1.235-1.235h16.47c.684 0 1.236.551 1.236 1.235 0 .683-.552 1.235-1.235 1.235ZM18.353 10.614V9.412h-4.941v1.202c-3.34 1.05-5.765 4.171-5.765 7.857v1.647h16.47V18.47c0-3.686-2.425-6.807-5.764-7.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.416 10.614h-.008v3.294h.008v-3.294ZM11.357 11.594h-.008v3.55h.008v-3.55ZM18.357 10.614h-.008v3.294h.008v-3.294ZM20.416 11.594h-.008v3.55h.008v-3.55Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "section2-icon-1_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6 9)",
    d: "M0 0h19.765v14H0z"
  })))));
};
export default SvgSection2Icon1;